import {
  FormWithSimpleMaterializedFormsFragment,
  TrainingFormWithTrainingDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import EditTrainingFormModal from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/EditTrainingForm'

type Data = {
  trainingId: string
  formId: string
}

export const EditSurveySettingsActivity: ActivityComponent<Data> = ({ trainingId, formId }) => {
  const { open, closeActivity } = useActivity()
  const { company } = useCurrentSession()
  const { data } = useQuery(TrainingFormWithTrainingDocument, {
    variables: { id: formId ?? '', trainingId: trainingId, companyId: company.id },
    skip: !open,
  })

  if (!open) return null

  const trainingForm: FormWithSimpleMaterializedFormsFragment | undefined =
    data?.forms.form ?? undefined

  if (!trainingForm) return null

  return (
    <EditTrainingFormModal
      onClose={closeActivity}
      onSuccess={() => {
        closeActivity()
        app.setFlash({
          type: 'correct',
          message: i18n.t('trainings.surveys.create.edit_modal.form_success_message'),
        })
      }}
      onError={() => {
        closeActivity()
        app.setFlash({
          type: 'wrong',
          message: i18n.t('trainings.surveys.create.edit_modal.form_error_message'),
        })
      }}
      isOpen={open}
      trainingForm={trainingForm}
    />
  )
}
